import { render } from "./EmbedLayout.vue?vue&type=template&id=94e08b76"
import script from "./EmbedLayout.vue?vue&type=script&lang=js"
export * from "./EmbedLayout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__